import React from "react";
import { Link } from "react-router-dom";
import VehicleCardFlag from "components/atoms/vehicleCardFlag";
import "./styles.scss";
import { currency } from "helpers/format.js";

const VehicleCard = ({ vehicle, availablePromotion }) => {
  const score = parseInt(vehicle.score);

  return (
    <div className="vehicleCard fluid">
      <Link to={"/usado/" + vehicle.id}>
        <div className="content">
          <div className="location">En {vehicle.location}</div>
          <div className="image">
            {vehicle.images.length > 0 && (
              <img src={vehicle.images[0]} alt={vehicle.name} />
            )}
          </div>

          {availablePromotion && (
            <VehicleCardFlag type="discount">Con descuento</VehicleCardFlag>
          )}

          {!availablePromotion && score < 8 && (
            <VehicleCardFlag type="opportunity">Oportunidad</VehicleCardFlag>
          )}

          {!availablePromotion && score >= 8 && (
            <VehicleCardFlag type="highlight">Destacado</VehicleCardFlag>
          )}

          <div className="data">
            <div className="brand">{vehicle.brand} / {vehicle.year}</div>
            <div className="model">{vehicle.name}</div>
            <div className="price">{currency(vehicle.price)}</div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default VehicleCard;
